import axios from "axios"
import { CHAIN_ID, setRuntimeRpcUrls } from "shared"

type RpcEndpoint = { url: string; priority: number; avg_latency_ms: number | null }
type RpcResponse = { chain_id: number; endpoints: RpcEndpoint[] }

const apiBase = () => {
    if (typeof window === "undefined") return ""
    const h = window.location.hostname
    // local dev or gh-pages: skip backend lookup
    if (h === "localhost" || h.endsWith("github.io")) return ""
    return ""  // same-origin via nginx /v0 proxy
}

export const bootstrapRpcUrls = async () => {
    const base = apiBase()
    if (base === "" && typeof window !== "undefined") {
        const h = window.location.hostname
        if (h === "localhost" || h.endsWith("github.io")) return
    }
    try {
        const res = await axios.get<RpcResponse>(`${base}/v0/rpc/${CHAIN_ID}`, {
            timeout: 3000,
        })
        const urls = res.data.endpoints.map((e) => e.url)
        if (urls.length > 0) {
            setRuntimeRpcUrls(CHAIN_ID, urls)
        }
    } catch {
        // ignore - fall back to hardcoded URLs in shared/chains.ts
    }
}
